export const DateFilterConfig = {
  defaultFilterValue: 24,
  defaultFilterValueForNews: 24,
  filterLabel: 'Content Age',
  filterTitle:'Content age',
  filterOptions: [
    {
      name: 'last 6 months',
      value: 6,
      id: '6m'
    },
    {
      name: '1 year',
      value: 12,
      id: '1y'
    },
    {
      name: '2 years',
      value: 24,
      id: '2y'
    },
    {
      name: '3 years',
      value: 36,
      id: '3y'
    },
    {
      name: '+3 years',
      value: 12000,
      id: 'all'
    }
  ],
  newsFilterOptions: [
    {
      name: '1 month',
      value: 1,
      id: '1m'
    },
    {
      name: 'last 6 months',
      value: 6,
      id: '6m'
    },
    {
      name: '1 year',
      value: 12,
      id: '1y'
    },
    {
      name: '2 years',
      value: 24,
      id: '2y'
    },
    {
      name: '3 years',
      value: 36,
      id: '3y'
    },
    {
      name: '+3 years',
      value: 12000,
      id: 'all'
    }
  ]

};

export const SortFilterConfig = {
  defaultFilterValue: 'Relevance',
};
